import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { WysiwygWithReactLink } from '../../../../global/components/wysiwyg-with-react-link';
import { Plan } from '../../../../Global/models/coverage-model';

interface Props {
    title: string;
    declinedMessage?: string;
    plan: Plan;
    enrolled?: boolean;
    planAvailable: boolean;
}

export function ReviewPlanDisplay(props: Props) {
    const { title, declinedMessage, plan, enrolled, planAvailable } = props;

    if (!planAvailable || !plan) return null;

    if (!enrolled)
        return (
            <>
                <ContentSpacer><h3>{title}</h3></ContentSpacer>
                <ContentSpacer><WysiwygWithReactLink content={declinedMessage} /></ContentSpacer>
            </>);

    return (
        <>
            <ContentSpacer><h3>{title}</h3></ContentSpacer>
            <p>{plan?.planName}</p>
            <LabelAndValue label={<p>{plan?.planTier}</p>} value={plan?.planPrice} />
        </>
    );
}

ReviewPlanDisplay.defaultProps = {
    enrolled: false,
    declinedMessage: null,
};

